// extracted by mini-css-extract-plugin
export default {"container":"Forbidden_container__SnIAC"};